import { accountEntityName } from '../../../../../backend/features/accounts/shared';
import { createLogCustom } from '../../../../../backend/features/audit';
import { changeMembersRoleAndStatusBulkActionEvent } from '../../../../../backend/features/audit/shared';
import { handleOrganizationMemberRoleAndStatus } from '../../../../../backend/features/organizations/bulk-actions/changeOrganizationMembersRoleAndStatus/handleOrganizationMemberRoleAndStatus';
import { changeOrganizationMembersRoleAndStatusBulkActionType, organizationEntityName, orgColumnForAuditIdReplacement, } from '../../../../../backend/features/organizations/shared';
import { allowOrgMembersEdit, getAccountsViewFilterNew, requireAnySystemPermission } from '../../../../../backend/features/permissions/shared';
import { forEachEntityRow } from '../../../../../backend/utils';
import { AuthError } from '@juvare/platform-app/App';
import { defineBulkAction } from '@juvare/platform-sdk-react/backend/features/bulk-actions';
export const changeOrganizationMembersRoleAndStatus = defineBulkAction({
    type: changeOrganizationMembersRoleAndStatusBulkActionType,
    onAuthBulkAction: (userContext, { createdBy, data }) => {
        if (!allowOrgMembersEdit(userContext.userState)) {
            throw new AuthError('Unauthorized');
        }
        const secureFilter = [...getAccountsViewFilterNew(userContext.userState), ...data.params.filter];
        if (!requireAnySystemPermission(userContext.userState, 'all-organizations-admin')) {
            secureFilter.push({ id: createdBy, op: '!=' });
        }
        return {
            secureFilter,
        };
    },
    onProcessBulkAction: (appContext, params) => {
        const accountStorage = appContext.storage(accountEntityName);
        const actionOwner = accountStorage.get(params.createdBy);
        const ids = [];
        forEachEntityRow(accountStorage, { filter: params.data.secureParams.secureFilter, orderBy: [{ column: 'email' }] }, (row, idx) => {
            const result = handleOrganizationMemberRoleAndStatus({
                appContext,
                secureBulkActionParams: params,
                row,
                accountStorage,
                actionOwner,
                processedIndex: idx,
            });
            if (result.updated) {
                ids.push(row.id);
            }
            return result;
        }, params.updateTotalCount);
        const orgStorage = appContext.storage(organizationEntityName);
        const organization = orgStorage.get(params.data.params.organizationId);
        const logCustomStrict = createLogCustom(appContext.audit);
        logCustomStrict({
            eventType: changeMembersRoleAndStatusBulkActionEvent,
            entity: organizationEntityName,
            entityId: params.data.params.organizationId,
            params: {
                ids,
                orgRole: params.data.params.newRole,
                orgStatus: params.data.params.newStatus,
                auditColumnValue: organization.columns[orgColumnForAuditIdReplacement],
            },
        });
    },
});
